import { render, staticRenderFns } from "./CharacterBuilderSpeciesAbilities.vue?vue&type=template&id=a3b9d0b0&lang=pug&"
import script from "./CharacterBuilderSpeciesAbilities.vue?vue&type=script&lang=ts&"
export * from "./CharacterBuilderSpeciesAbilities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports